module.exports = __webpack_public_path__ + "static/3t-021c27e73f9721344768d59a77d27172.jpg";